import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueSweetalert2 from 'vue-sweetalert2';
import routes from './routes/routes'
import 'sweetalert2/dist/sweetalert2.min.css';
import Vue2Filters from 'vue2-filters'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import reactiveStorage from "vue-reactive-storage";
import VueGtm from 'vue-gtm';
import VueGtag from "vue-gtag";

import 'uikit/dist/css/uikit.css';
import 'uikit/dist/js/uikit';
import 'uikit/dist/js/uikit-icons.js';
var SocialSharing = require('vue-social-sharing');

Vue.component('vue-phone-number-input', VuePhoneNumberInput);
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueSweetalert2)
Vue.use(Vue2Filters)
Vue.use(SocialSharing)
Vue.use(reactiveStorage, {
    "token": "",
    "reference": "",
    "name": "",
    "products": [],
    "coupons": [],
    "currentMethod": ""
});



require('@/assets/css/main.css');
// configure router
export const router = new VueRouter({
    mode: 'history',
    routes, // short for routes: routes
    linkActiveClass: 'nav-item active',
    scrollBehavior: (to) => {
        if (to.hash) {
            return {selector: to.hash}
        } else {
            return {x: 0, y: 0}
        }
    }
})

Vue.use(VueGtm, {
    id: 'GTM-PTGZ5M3',
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});

Vue.use(VueGtag, {
    config: { id: "UA-153560100-1" }
}, router);

new Vue({
    render: h => h(App),
    router,
}).$mount('#app')
